import { useMutation, useQuery } from "@tanstack/react-query"
import { deleteApiKey, generateApiKey, listApiKeys } from "@/lib/http/settings"

export const useListApiKeys = () => useQuery({ queryKey: ["credentials"], queryFn: listApiKeys })

export const useGenerateApiKey = () =>
  useMutation({
    mutationFn: ({ name, description }: { name: string; description: string }) => generateApiKey(name, description),
  })

export const useApiKeyDelete = () => useMutation({ mutationFn: (id: string) => deleteApiKey(id) })
